var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreinos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 4.14941V6.48047H13.8616V4.14941H6.96875Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 6.47852V4.14746H19.0561C19.3776 4.14746 19.6382 4.40806 19.6382 4.72956V5.89642C19.6382 6.21792 19.3776 6.47852 19.0561 6.47852H18.2188Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60938 4.14844V6.47949H1.77206C1.45056 6.47949 1.18997 6.2189 1.18997 5.8974V4.73053C1.18997 4.40904 1.45056 4.14844 1.77206 4.14844H2.60938Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07404 0.828125H5.53045C5.03686 0.828125 4.63672 1.22826 4.63672 1.72186V8.90487C4.63672 9.39847 5.03686 9.79861 5.53045 9.79861H6.07404C6.56763 9.79861 6.96778 9.39847 6.96778 8.90487V1.72186C6.96778 1.22826 6.56763 0.828125 6.07404 0.828125Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74165 2.44922H3.50702C3.01342 2.44922 2.61328 2.84936 2.61328 3.34295V7.28237C2.61328 7.77597 3.01342 8.17611 3.50702 8.17611H3.74165C4.23524 8.17611 4.63538 7.77597 4.63538 7.28237V3.34295C4.63538 2.84936 4.23524 2.44922 3.74165 2.44922Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7638 9.79883H15.3074C15.801 9.79883 16.2012 9.39869 16.2012 8.90509V1.72208C16.2012 1.22848 15.801 0.828345 15.3074 0.828345H14.7638C14.2703 0.828345 13.8701 1.22848 13.8701 1.72208V8.90509C13.8701 9.39869 14.2703 9.79883 14.7638 9.79883Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0962 8.17773H17.3309C17.8245 8.17773 18.2246 7.7776 18.2246 7.284V3.34458C18.2246 2.85098 17.8245 2.45085 17.3309 2.45085H17.0962C16.6027 2.45085 16.2025 2.85098 16.2025 3.34458V7.284C16.2025 7.7776 16.6027 8.17773 17.0962 8.17773Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreinos);
export default __webpack_public_path__ + "static/media/Treinos.459d9823283e750e4eb50daf21ba1c9b.svg";
export { ForwardRef as ReactComponent };